import { render } from "./RequestsReceived.vue?vue&type=template&id=608d0d64&scoped=true"
import script from "./RequestsReceived.vue?vue&type=script&lang=js"
export * from "./RequestsReceived.vue?vue&type=script&lang=js"

import "./RequestsReceived.vue?vue&type=style&index=0&id=608d0d64&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-608d0d64"

export default script